module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-card', {
    attrs: {
      "tile": ""
    }
  }, [_c('v-card-title', [_c('h3', [_vm._v("Commissions")])]), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-text', [_c('v-data-table', {
    attrs: {
      "items": _vm.caseLogManagersFlow,
      "headers": _vm.managersTableHeaders,
      "disable-initial-sort": "",
      "no-data-text": "No managers",
      "hide-actions": ""
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('td', [_vm._v(_vm._s(props.item.created_at || _vm.caseModel.created_at))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.manager.name + ' (' + props.item.manager.email + ')'))]), _vm._v(" "), _c('td', {
          class: _vm.canAddCommissions ? 'quantity_bgcolor' : ''
        }, [_c('v-edit-dialog', {
          attrs: {
            "large": "",
            "lazy": "",
            "persistent": ""
          },
          scopedSlots: _vm._u([(_vm.canAddCommissions) ? {
            key: "input",
            fn: function() {
              return [_c('v-text-field', {
                attrs: {
                  "label": "Commissions",
                  "single-line": "",
                  "autofocus": ""
                },
                on: {
                  "change": _vm.updateCommissions
                },
                model: {
                  value: (props.item.commissions),
                  callback: function($$v) {
                    _vm.$set(props.item, "commissions", $$v)
                  },
                  expression: "props.item.commissions"
                }
              })]
            },
            proxy: true
          } : null], null, true)
        }, [(_vm.caseModel.status === 'closed') ? _c('div', [_vm._v("$" + _vm._s(props.item.commissions))]) : _c('div', [_vm._v("Case not closed")])])], 1)]
      }
    }])
  })], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6162a5d8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/CaseCommissions.vue
// module id = 997
// module chunks = 1